import React, { useState } from 'react';
import { X } from 'lucide-react';

/**
 * Thumbnails + lightbox. Presentation-only.
 * `images` is an array of stable URL strings.
 */
export default function ReceiptImages({ images, colors }) {
  const [lightboxIdx, setLightboxIdx] = useState(null);

  if (images.length === 0) return null;

  return (
    <>
      <div className="mb-4" data-testid="detail-images-section">
        <p
          className="text-[11px] font-semibold uppercase tracking-wider mb-2"
          style={{ color: colors.textMuted }}
        >
          Receipt images
        </p>
        <div className="flex gap-3 overflow-x-auto pb-2">
          {images.map((url, idx) => (
            <button
              key={url}
              data-testid={`detail-thumb-${idx}`}
              onClick={() => setLightboxIdx(idx)}
              className="w-24 h-24 rounded-xl border overflow-hidden shrink-0 transition-opacity hover:opacity-80"
              style={{ backgroundColor: colors.surface, borderColor: colors.border }}
            >
              <img src={url} alt={`Receipt ${idx + 1}`} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </div>

      {lightboxIdx !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
          data-testid="detail-lightbox"
          onClick={() => setLightboxIdx(null)}
        >
          <button
            data-testid="lightbox-close"
            onClick={() => setLightboxIdx(null)}
            className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/15 flex items-center justify-center text-white z-10"
          >
            <X size={22} />
          </button>
          <img
            src={images[lightboxIdx]}
            alt="Receipt full"
            className="max-w-[90vw] max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
